import { Currency } from '@/core/currency/interfaces';

const DKK: Currency = {
    name: 'Danish Krone',
    demonym: 'Danish',
    majorSingle: 'Krone',
    majorPlural: 'Kroner',
    codeNumeric: '208',
    symbol: 'kr.',
    symbolNative: 'kr.',
    minorSingle: 'Øre',
    minorPlural: 'Øre',
    ISOdigits: 2,
    decimals: 2,
    numToBasic: 100,
    code: 'DKK',
    delimiters: {
        thousands: '.',
        decimal: ','
    }
};

export default DKK;
